import React from 'react'

import Section from './Section'
import PageLinkItem from './PageLinkItem'
import { links } from '../../../constants/links'

const Company = () => (
  <Section title="Company">
    <PageLinkItem to={links.about}>About Us</PageLinkItem>
    <PageLinkItem to={links.onlineTuition}>Online Tuition</PageLinkItem>
  </Section>
)

export default Company
